import axios from 'axios';

// Add function to load Google Fonts
const loadFont = (fontFamily) => {
  if (!fontFamily || fontFamily === 'Helvetica Neue, sans-serif') return;

  const fontId = `font-${fontFamily.replace(/\s/g, '-')}`;
  const existing = document.getElementById(fontId);
  if (existing) return;

  const fontLink = document.createElement('link');
  fontLink.id = fontId;
  fontLink.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s/g, '+')}&display=swap`;
  fontLink.rel = 'stylesheet';
  document.head.appendChild(fontLink);
};

const monthlyPaymentPreview = async (widget) => {
  // Load/refresh the widget script if URL/data changed
  if (widget.firstLoad) {
    window.widgetJson = widget;
    const scriptId = widget.name;

    window.mjFrontend = process.env.REACT_APP_CLIENT_URL;
    window.mjServerUrl = process.env.REACT_APP_SERVER_URL;

    // First load the CSS
    const styleElement = document.createElement('link');
    styleElement.href = window.mjFrontend + '/styles/widget/monthlyPayments.css';
    styleElement.rel = "stylesheet";
    styleElement.type = "text/css";
    styleElement.id = 'mjwi-style-monthlypayment';
    document.head.appendChild(styleElement);

    const existingScript = document.getElementById('mjwi-script-' + scriptId);
    if (existingScript) {
      existingScript.parentNode.removeChild(existingScript);
    }

    const scriptElement = document.createElement('script');
    scriptElement.src = process.env.REACT_APP_CLIENT_URL + '/scripts/widget/' + scriptId + '.js';
    try {
      const response = await axios.head(scriptElement.src, { timeout: 5000 });
      if (response.status === 200) {
        scriptElement.type = 'text/javascript';
        scriptElement.id = 'mjwi-script-' + scriptId;
        document.head.appendChild(scriptElement);
      }
    } catch {
      console.log('Main file does not exist');
    }
  } else {
    const htmlData = widget.htmlData.monthlypayment;
    const containerData = htmlData.container;
    const headerData = htmlData.header;
    const fieldData = htmlData.fields;
    const resultData = htmlData.result;
    const colorData = htmlData.colors;

    // Load fonts for all relevant font families
    [headerData.fontFamily, resultData.fontFamily, fieldData.fontFamily].forEach(font => loadFont(font));

    // Update fixedDownPaymentPercent in monthlypayment.js
    window.fixedDownPaymentPercent = fieldData.defaultDownPaymentPercent || 20;

    // Use homePrice styles as universal styles for all fields
    const universalFieldTextColor = fieldData.textColor || '#333333';
    const universalFieldFontSize = fieldData.fontSize || '16px';
    const universalFieldFontFamily = fieldData.fontFamily || 'Helvetica Neue, sans-serif';
    const universalFieldFontWeight = fieldData.fontWeight || 'normal';

    // Get all relevant elements
    const containerEl = document.querySelector('.mj-monthlypayment-widget');
    const headerEl = document.querySelector('.header-title');
    const headerSubtitleEl = document.querySelector('.header-subtitle');
    const resultEl = document.querySelector('.result-section');
    const resultTitleEl = document.querySelector('.costs-title');
    const resultValueEl = document.querySelector('.cost-value');
    const resultPeriodEl = document.querySelector('.cost-period');
    const layoutEl = document.querySelector('.mj-monthlypayment-widget');
    const principalDotEls = document.querySelectorAll('.segment-principal, .principalAndInterest .color-dot');
    const taxDotEls = document.querySelectorAll('.segment-tax, .propertyTax .color-dot');
    const insuranceDotEls = document.querySelectorAll('.segment-home-insurance, .homeInsurance .color-dot');
    const hoaDotEls = document.querySelectorAll('.hoaFees .color-dot');
    // const mortgageDotEls = document.querySelectorAll('.segment-mortgage-insurance, .mortgageInsurance .color-dot');
    const progressBarEl = document.querySelector('.progress-bar');

    // Field-specific elements
    const principalAndInterestEl = document.querySelector('.cost-section.principalAndInterest');
    const homePriceEl = document.querySelector('.cost-section.homePrice');
    const downPaymentEl = document.querySelector('.cost-section.downPayment');
    const loanTypeEl = document.querySelector('.cost-section.loanType');
    const interestRateEl = document.querySelector('.cost-section.interestRate');
    const propertyTaxEl = document.querySelector('.cost-section.propertyTax');
    const homeInsuranceEl = document.querySelector('.cost-section.homeInsurance');
    const hoaFeesEl = document.querySelector('.cost-section.hoaFees');
    // const mortgageInsuranceEl = document.querySelector('.cost-section.mortgageInsurance');

    // Update container styles
    if (containerEl) {
      containerEl.style.backgroundColor = containerData.bgColor;
      containerEl.style.borderRadius = containerData.borderRadius;
      containerEl.style.padding = containerData.padding;
      containerEl.style.boxShadow = containerData.shadow;
      containerEl.style.borderColor = containerData.borderColor;
    }

    // Update header
    if (headerEl) {
      headerEl.style.color = headerData.textColor;
      headerEl.textContent = headerData.title;
      headerEl.style.fontFamily = headerData.fontFamily;
      headerEl.style.fontSize = `${headerData.fontSize}px`;
      headerEl.style.fontWeight = headerData.fontWeight;
      headerEl.style.textAlign = headerData.textAlign;
    }

    // Update header subtitle
    if (headerSubtitleEl) {
      headerSubtitleEl.style.color = headerData.textColor;
      headerSubtitleEl.style.fontFamily = headerData.fontFamily;
      headerSubtitleEl.style.textAlign = headerData.textAlign;
    }

    // Update layout
    if (layoutEl) {
      layoutEl.classList.remove('horizontal-view', 'two-column-view', 'mobile-view');
      if (window.innerWidth < 768) {
        layoutEl.classList.add('mobile-view');
      } else {
        layoutEl.classList.add(htmlData.layout?.template === 'horizontal' ? 'horizontal-view' : 'two-column-view');
      }
    }

    // Update result section
    if (resultEl) {
      resultEl.style.color = resultData.textColor;
      resultEl.style.fontFamily = resultData.fontFamily;
      resultEl.style.fontSize = resultData.fontSize;
      resultEl.style.fontWeight = resultData.fontWeight;
      resultEl.style.textAlign = resultData.textAlign;
    }

    // Update result title
    if (resultTitleEl) {
      resultTitleEl.style.color = resultData.textColor;
      resultTitleEl.style.fontFamily = resultData.fontFamily;
      resultTitleEl.style.fontWeight = resultData.fontWeight;
      resultTitleEl.style.textAlign = resultData.textAlign;
    }

    // Update result value
    if (resultValueEl) {
      resultValueEl.style.color = resultData.textColor;
      resultValueEl.style.fontFamily = resultData.fontFamily;
      resultValueEl.style.fontSize = resultData.fontSize;
      resultValueEl.style.fontWeight = resultData.fontWeight;
    }

    if (resultPeriodEl) {
      resultPeriodEl.style.color = resultData.textColor;
      resultPeriodEl.style.fontFamily = resultData.fontFamily;
      resultPeriodEl.style.fontSize = resultData.fontSize;
      resultPeriodEl.style.fontWeight = resultData.fontWeight;
    }

    // Update color dots
    if (principalDotEls.length > 0) {
      principalDotEls.forEach(el => {
        el.style.backgroundColor = colorData.principalDot || resultData.principalColor;
      });
    }

    if (taxDotEls.length > 0) {
      taxDotEls.forEach(el => {
        el.style.backgroundColor = colorData.taxDot || resultData.taxColor;
      });
    }

    if (insuranceDotEls.length > 0) {
      insuranceDotEls.forEach(el => {
        el.style.backgroundColor = colorData.insuranceDot || resultData.insuranceColor;
      });
    }

    if (hoaDotEls.length > 0) {
      hoaDotEls.forEach(el => {
        el.style.backgroundColor = colorData.hoaDot;
      });
    }

    // if (mortgageDotEls.length > 0) {
    //   mortgageDotEls.forEach(el => {
    //     el.style.backgroundColor = colorData.mortgageDot;
    //   });
    // }

    // Update progress bar colors
    if (progressBarEl) {
      const principalSegment = progressBarEl.querySelector('.segment-principal');
      const taxSegment = progressBarEl.querySelector('.segment-tax');
      const homeInsuranceSegment = progressBarEl.querySelector('.segment-home-insurance');
      const hoaFeesSegment = progressBarEl.querySelector('.segment-hoa-fees');
      // const mortgageInsuranceSegment = progressBarEl.querySelector('.segment-mortgage-insurance');

      if (principalSegment) principalSegment.style.backgroundColor = colorData.principalDot || resultData.principalColor;
      if (taxSegment) taxSegment.style.backgroundColor = colorData.taxDot || resultData.taxColor;
      if (homeInsuranceSegment) homeInsuranceSegment.style.backgroundColor = colorData.insuranceDot || resultData.insuranceColor;
      if (hoaFeesSegment) hoaFeesSegment.style.backgroundColor = colorData.hoaDot || '#9f7aea';
      // if (mortgageInsuranceSegment) mortgageInsuranceSegment.style.backgroundColor = colorData.mortgageDot;
    }

    // Update field-specific styles using homePrice styles for all fields
    const applyFieldStyles = (element) => {
      if (element) {
        // Update header
        const header = element.querySelector('.cost-label');
        if (header) {
          header.style.color = universalFieldTextColor;
          header.style.fontFamily = universalFieldFontFamily;
          header.style.fontSize = universalFieldFontSize;
          header.style.fontWeight = universalFieldFontWeight;
        }

        // Update field-text elements
        const fieldTexts = element.querySelectorAll('.field-text');
        fieldTexts.forEach(text => {
          text.style.color = universalFieldTextColor;
          text.style.fontFamily = universalFieldFontFamily;
        });

        // Update tax-details elements
        const propertyFieldTexts = element.querySelectorAll('.tax-details');
        propertyFieldTexts.forEach(text => {
          text.style.color = universalFieldTextColor;
          text.style.fontFamily = universalFieldFontFamily;
        });

        // Update info icon
        const infoIcon = element.querySelector('.info-icon');
        if (infoIcon) {
          infoIcon.style.color = universalFieldTextColor;
          infoIcon.style.fontSize = universalFieldFontSize;
          infoIcon.style.fontWeight = universalFieldFontWeight;
        }

        // Update slider labels (if applicable)
        const sliderLabels = element.querySelectorAll('.slider-labels .field-text');
        sliderLabels.forEach(label => {
          label.style.color = universalFieldTextColor;
          label.style.fontFamily = universalFieldFontFamily;
        });
      }
    };

    // Apply styles to each field using homePrice styles
    applyFieldStyles(principalAndInterestEl);
    applyFieldStyles(homePriceEl);
    applyFieldStyles(downPaymentEl);
    applyFieldStyles(loanTypeEl);
    applyFieldStyles(interestRateEl);
    applyFieldStyles(propertyTaxEl);
    applyFieldStyles(homeInsuranceEl);
    applyFieldStyles(hoaFeesEl);
    // applyFieldStyles(mortgageInsuranceEl);

    // Format currency helper
    var formatCurrency = (amount) => {
      return new Intl.NumberFormat("en-US", { 
        style: "currency", 
        currency: "USD", 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 0 
      }).format(amount);
    };

    function formatLargeCurrency(amount) {
      if (amount >= 1000000) {
        return `$${(amount / 1000000).toFixed(3)}M`;
      } else if (amount >= 1000) {
        return `$${(amount / 1000).toFixed(0)}K`;
      }
      return formatCurrency(amount);
    }

    // Update field-specific settings (e.g., sliders, default values, visibility)
    if (homePriceEl) {
      const homePriceInput = homePriceEl.querySelector('#homePrice');
      const homePriceSliderContainer = homePriceEl.querySelector('.slider-container');
      if (homePriceInput) {
        homePriceInput.value = new Intl.NumberFormat("en-US").format(fieldData.homePriceDefaultValue || 1550000);
      }
      if (homePriceSliderContainer) {
        if (fieldData.homePriceShowSlider) {
          homePriceSliderContainer.style.display = 'block';
          const slider = homePriceSliderContainer.querySelector('#homePriceSlider');
          if (slider) {
            // Ensure min and max are valid
            let min = fieldData.homePriceSliderMin || 1240000;
            let max = fieldData.homePriceSliderMax || 1860000;
            let defaultValue = fieldData.homePriceDefaultValue || 1550000;
            
            // Fix 1: Ensure max is never less than default
            if (max < defaultValue) {
                max = defaultValue;
            }
            
            // Fix 2: If max is less than min, set min to 1
            if (max < min) {
                min = 1;
            }
            
            slider.min = min;
            slider.max = max;
            slider.value = defaultValue;
            
            const labels = homePriceSliderContainer.querySelectorAll('.slider-labels .field-text');
            if (labels[0]) labels[0].textContent = formatLargeCurrency(min);
            if (labels[1]) labels[1].textContent = formatLargeCurrency(max);
          }
        } else {
          homePriceSliderContainer.style.display = 'none';
        }
      }
    }

    if (downPaymentEl) {
      const downPaymentInput = downPaymentEl.querySelector('#downPayment');
      const percentageInput = downPaymentEl.querySelector('.percent-input-wrapper');
      const downPaymentSliderContainer = downPaymentEl.querySelector('.slider-container');

      if (downPaymentInput) {
        downPaymentInput.value = new Intl.NumberFormat("en-US").format(
          ((fieldData.homePriceDefaultValue || 1550000) * (fieldData.defaultDownPaymentPercent || 20)) / 100
        );
      }

      if (percentageInput) {
        const percentInput = percentageInput.querySelector('input#downPaymentPercent');
        if (percentInput) {
          percentInput.value = (fieldData.defaultDownPaymentPercent || 20).toFixed(2);
        }
      }

      if (downPaymentSliderContainer) {
        downPaymentSliderContainer.style.display = fieldData.downPaymentShowSlider ? 'block' : 'none';
        const slider = downPaymentSliderContainer.querySelector('#downPaymentPercentSlider');
        if (slider) {
          slider.value = fieldData.defaultDownPaymentPercent || 20;
        }
      }
    }

    if (interestRateEl) {
      const interestRateInput = interestRateEl.querySelector('#interestRate');
      if (interestRateInput) {
        interestRateInput.value = fieldData.interestRateDefaultValue || 6;
      }
    }

    if (propertyTaxEl) {
      const propertyTaxInput = propertyTaxEl.querySelector('#propertyTax');
      const taxDetails = propertyTaxEl.querySelector('.tax-details');
      if (propertyTaxInput) {
        propertyTaxInput.value = new Intl.NumberFormat("en-US").format(((fieldData.homePriceDefaultValue || 1550000) * (fieldData.propertyTaxAnnualRate || 1.25)) / 100 / 12);
      }
      if (taxDetails) {
        const percentage = taxDetails.querySelector('.percentage');
        const taxValue = taxDetails.querySelector('.tax-value');
        if (percentage) percentage.textContent = `(${fieldData.propertyTaxAnnualRate || 1.25}%`;
        if (taxValue) taxValue.textContent = `$${new Intl.NumberFormat("en-US").format(((fieldData.homePriceDefaultValue || 1550000) * (fieldData.propertyTaxAnnualRate || 1.25)) / 100)}`;
      }
    }

    if (homeInsuranceEl) {
      const homeInsuranceInput = homeInsuranceEl.querySelector('#homeInsurance');
      if (homeInsuranceInput) {
        homeInsuranceInput.value = new Intl.NumberFormat("en-US").format(fieldData.homeInsuranceDefaultValue || 388);
      }
    }

    if (hoaFeesEl) {
      const hoaFeesInput = hoaFeesEl.querySelector('#hoaFees');
      if (hoaFeesInput) {
        hoaFeesInput.value = new Intl.NumberFormat("en-US").format(fieldData.hoaFeesDefaultValue || 0);
      }
    }

    // if (mortgageInsuranceEl) {
    //   const mortgageInsuranceInput = mortgageInsuranceEl.querySelector('#mortgageInsurance');
    //   const thresholdNote = mortgageInsuranceEl.querySelector('.mortgage-ins-note');
    //   if (mortgageInsuranceInput) {
    //     mortgageInsuranceInput.value = '0';
    //   }
    //   if (thresholdNote) {
    //     thresholdNote.style.display = fieldData.mortgageInsuranceShowThresholdNote ? 'block' : 'none';
    //     thresholdNote.textContent = `$0 if down payment is ${fieldData.mortgageInsuranceThreshold || 20}%+`;
    //   }
    // }

    // Load fonts if changed
    const fontFamilies = [universalFieldFontFamily].filter(f => f);

    if (fontFamilies.length > 0) {
      const existingFonts = document.getElementById('mjwi-fonts-monthlypayment');
      if (existingFonts) existingFonts.remove();

      const fontLink = document.createElement('link');
      fontLink.id = 'mjwi-fonts-monthlypayment';
      fontLink.href = `https://fonts.googleapis.com/css2?${fontFamilies.map(f => `family=${f.split(' ').join('+')}`).join('&')}&display=swap`;
      fontLink.rel = 'stylesheet';
      document.head.appendChild(fontLink);
    }

    setTimeout(() => {
      if (window.triggerFieldUpdates) {
        window.triggerFieldUpdates();
      } else if (window.calculateAndUpdate) {
        window.calculateAndUpdate();
      }
      
      if (window.updateSliderPositions) {
        window.updateSliderPositions();
      }
    }, 200);

    // Re-run calculations to update all values
    if (window.calculateAndUpdate) {
      window.calculateAndUpdate();
    }
  }
};

export default monthlyPaymentPreview;